if(window.location.search.indexOf('debug=1') > -1){
  Cookies.remove('ageverification');
}

window._isSP = false;
if(window.innerWidth <= 768){
  _isSP = true;
}
var _CommonInit = function(){

  var mouse_event = {
    "start": _isSP ? "touchstart" : "mousedown",
    "move": _isSP ? "touchmove" : "mousemove",
    "end": _isSP ? "touchend" : "mouseup mouseleave"
  };

  var _body = document.getElementsByTagName("body")[0];

  // Mobile Drawer
  var _mobileDrawer = document.getElementsByClassName("mobile-navigation-drawer")[0];
  var _mobileDrawerTier = _mobileDrawer.getElementsByClassName("navigation__tier-1")[0];
  var _mobileDrawerTierA = _mobileDrawerTier.getElementsByTagName("a");
  var _mobileDrawerProductTitle = _mobileDrawer.getElementsByClassName("navigation__mobile-products-title")[0];
  var _mobileToggleButton = document.getElementsByClassName("mobile-nav-toggle");
  var _mobileToggleCloseButton = _mobileDrawer.getElementsByClassName("mobile-nav-toggle")[0];
  var _count = 0;
  var _sheets = document.styleSheets
  var _sheet = _sheets[_sheets.length - 1];

  for(var a = 0; a < _mobileDrawerTierA.length; a++){
    _mobileDrawerTierA[a].classList.add("wait");
    var _mobileDrawerTierAText = _mobileDrawerTierA[a].innerText;
    _mobileDrawerTierAText = "<div><span>" + _mobileDrawerTierAText + "</span></div>";
    _mobileDrawerTierA[a].innerHTML = _mobileDrawerTierAText;
  }

  if(_mobileDrawerProductTitle){
    _mobileDrawerProductTitle.classList.add("wait");
    var _mobileDrawerProductTitleText = _mobileDrawerProductTitle.innerText;
    _mobileDrawerProductTitleText = "<div><span>" + _mobileDrawerProductTitleText + "</span></div>";
    _mobileDrawerProductTitle.innerHTML = _mobileDrawerProductTitleText;
  }

  var _waitElm =_mobileDrawer.getElementsByClassName("wait");
  Array.from(_waitElm).forEach(function(a, i, elm){
    a.getElementsByTagName("span")[0].style.transitionDelay = ((i * 75) + 300).toString() + "ms";
    _count = i + 1;
  });


  //スタイルルールの追加
  _sheet.insertRule(
    '.mobile-nav-toggle:before { transition-delay: ' + ((_count * 75) + 300).toString() + "ms" + '}',
    _sheet.cssRules.length
  );
  _sheet.insertRule(
    '.mobile-nav-toggle:after { transition-delay: ' + ((_count * 75) + 300).toString() + "ms" + '}',
    _sheet.cssRules.length
  );

  var _DrawerOpen = function(){
    if(_body.classList.contains("enable-mobile-nav-transition")) return;
    var _elm =_mobileDrawer.getElementsByClassName("wait");
    Array.from(_elm).forEach(function(a, i, elm){
      a.getElementsByTagName("span")[0].style.transitionDelay = ((i * 75) + 300).toString() + "ms";
      a.classList.add("animate");
    });
    var _timer = setTimeout(function(){
      _mobileToggleCloseButton.classList.add("animate-toggle");
      clearTimeout(_timer);
    }, (_count * 75) + 300);
  };
  var _DrawerClose = function(){
    var _elm =_mobileDrawer.getElementsByClassName("animate");
    console.log(_elm);
    Array.from(_elm).forEach(function(a, i, elm){
      a.getElementsByTagName("span")[0].style.transitionDelay = "";
      a.classList.remove("animate");
    });
    _mobileToggleCloseButton.style.transitionDelay = "";
    _mobileToggleCloseButton.classList.remove("animate-toggle");
  };

  var _animateDrawerElement = function(event){
    if(!window._isSP) return;
    if(!_body.classList.contains("reveal-mobile-nav")){
      // open
      _DrawerOpen();
    }else{
      // close
      _DrawerClose();
    }
  };

  for(var m = 0; m < _mobileToggleButton.length; m++){
    _mobileToggleButton[m].addEventListener('click', _animateDrawerElement);
  }


  // Age Verification
  var _verification = document.getElementById('age_verification');
  if( Cookies.get('ageverification') === 'yes' || sessionStorage.getItem("ageverification")){
    _verification.parentNode.classList.add('yes');
  }else{
    _verification.parentNode.classList.remove('yes');
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    var _btn = document.getElementsByClassName('age-verification--btn');
    var _check = document.getElementById('age_verification_check');

    var _Verify = function(event){
      if(event.currentTarget.dataset['ageVerification'] === 'yes'){
        if(_check.checked){
          Cookies.set('ageverification', 'yes', {path:'/', expires: 30});
        }
        sessionStorage.setItem("ageverification", "1");
        _verification.parentNode.classList.add('fadeout');
        var _timer = setTimeout(function(){
          _verification.parentNode.classList.add('yes');
          document.getElementsByTagName('body')[0].style.overflow = '';
          clearTimeout(_timer);
        }, 500);

      }else{
        //window.location.href = ''
      }
    };

    var _TapEnd = function(event){
      event.currentTarget.classList.remove("tap");
      event.currentTarget.removeEventListener(mouse_event.end, _TapEnd);
    }
    var _TapStart = function(event){
      if(!_isSP) return;
      event.currentTarget.classList.add("tap");
      event.currentTarget.addEventListener(mouse_event.end, _TapEnd);
    };

    for(var i = 0; i < _btn.length;i++){
      _btn[i].addEventListener('click', _Verify);
      _btn[i].addEventListener(mouse_event.start, _TapStart);
    }
  }

  // Resize Event
  var Resize = function(){
    if(window.innerWidth <= 768){
      _isSP = true;
    }else{
      _isSP = false;
    }
    mouse_event = {
      "start": _isSP ? "touchstart" : "mousedown",
      "move": _isSP ? "touchmove" : "mousemove",
      "end": _isSP ? "touchend" : "mouseup mouseleave"
    };
  }
  window.addEventListener('resize', Resize);
  Resize();
};

window.addEventListener('load', _CommonInit);